import React, {useState, useEffect} from "react";
import {FilterDelete} from '../../../../utils/HelpFunctions';
import {useSnackbar} from "notistack";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import ArrayStore from "devextreme/data/array_store";
import {db, storage} from "../../../../firebase/Firebase";
import {FormContainer, Layout, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";
import List from "devextreme-react/list";
import {saveAs} from 'file-saver';
import Text from "../../../../palette/Text";
import Divider from '@material-ui/core/Divider';
import Dialog from "../../../../palette/Dialog";

function DownloadDocuments(props) {

    const {trigger, setTrigger, DataStore, dataSource, triggerEdit, setEditChoice, dataEdit} = props

    const {companyName, idCompany,} = DataStore

    const [documentsLinks, setDocumentsLinks] = useState([])
    const [success, setSuccess] = useState(false)
    const [dataId, setDataId] = useState(null)
    const [openDialog, setOpenDialog] = useState(false)

    const {enqueueSnackbar} = useSnackbar();

    const mainPath = db.collection(companyName).doc(idCompany).collection('DriverManagement').doc(dataSource.id)

    useEffect(() => {
        const dataArr = []
        dataSource.documents.forEach((doc, i) => {
            const newObject = doc
            newObject.id = i + 1
            dataArr.push(newObject)
        })
        setDocumentsLinks(dataArr);
    }, [dataSource, triggerEdit])

    const data = new ArrayStore({
        key: 'id',
        data: documentsLinks
    });

    const onClickDownLoad = (data) => {
        const docTypeArray = data.bucketPath.split('/')
        const bucketPath = data.bucketPath

        const docType = docTypeArray[docTypeArray.length - 1]

        const storageRef = storage.ref(bucketPath)
        storageRef.getDownloadURL().then(function (url) {
            saveAs(url, `${docType}`);
        }).catch(function () {
            enqueueSnackbar('Error intente nuevamente', {variant: 'error'})
        })
    }

    const openDialogPopup = (ID) => {
        setOpenDialog(true)
        setDataId(ID)
    }

    const onDelete = async () => {
        const filterResults = FilterDelete(dataSource.documents, 'id', dataId)
        setDocumentsLinks(filterResults);
        await mainPath.update({
            documents: filterResults
        }).then(() => {
            setSuccess(true)
            setTrigger(!trigger)
            setOpenDialog(false)
            setTimeout(() => {
                setSuccess(false)
            }, 2000)
        }).catch(() => {
            setSuccess(false)
            setOpenDialog(false)
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            setTrigger(!trigger)
        })
    }

    function ItemTemplate(data) {
        return (

            <Layout row center space>
                <Text hover={false} color={'#333'} weight={'800'} text={data.name} size={14}/>
                <LayoutChild color={'transparent'} center row width={'auto'}>
                    <i className="fas fa-download" style={{color: '#0288D1', fontSize: 20}}
                       onClick={() => onClickDownLoad(data)}/>
                    <i className="far fa-trash-alt" onClick={() => {
                        openDialogPopup(data.id)
                    }}
                       style={{color: 'red', fontSize: 20, marginLeft: 15}}/>
                </LayoutChild>
            </Layout>
        )
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="drivers-download-documents">
                <HeaderPage icon={'fas fa-download'} text={`Documentos de ${dataSource?.name} ${dataSource?.lastName}`}
                            load={true} textLoad={'Descargando....'}/>
                <FormContainer>
                    <div className="list-container-prz">
                        <LayoutChild width="100%" center padding={10}>
                            <Text hover={false} text={'Documentos'} size={15} color="#1A5487" weight={'900'}/>
                        </LayoutChild>
                        <Divider style={{background: 'white'}}/>
                        <Dialog title="Eliminar documento" text={'Esta seguro que desea eliminar este documento?'}
                                onClick={onDelete} openDialog={openDialog} setOpenDialog={setOpenDialog}
                                textButton={'Eliminar'} load={!openDialog}/>
                        <List
                            dataSource={data}
                            height={'auto'}
                            itemRender={ItemTemplate}
                            showSelectionControls={true}
                        />
                    </div>
                    <VerticalSpace space={10}/>
                    {success && <Alerts severity={'success'} body={`Documento eliminado exitosamente!`}/>}
                    <VerticalSpace space={5}/>
                    <Layout row center positionL>
                        <Button
                            icon="far fa-arrow-alt-circle-left"
                            text="Volver"
                            onClick={() => {
                                setEditChoice('')
                            }}/>
                    </Layout>
                </FormContainer>
            </div>
        </>
    )
}

export default DownloadDocuments
